"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuid = uuid;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
function uuid() {
  // 最多使用 1e6，否则 IE toString() 会出来指数表示法
  var timeLead = 1e6;
  return (+new Date() * timeLead + Math.random() * (timeLead - 1)).toString(36);
}